import { render, staticRenderFns } from "./product-type-controller.vue?vue&type=template&id=502882a0&scoped=true&"
import script from "./product-type-controller.vue?vue&type=script&lang=js&"
export * from "./product-type-controller.vue?vue&type=script&lang=js&"
import style0 from "./product-type-controller.vue?vue&type=style&index=0&id=502882a0&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "502882a0",
  null
  
)

export default component.exports